import * as React from "react";
import { observer } from "mobx-react";
import { Header } from "../components";
import { Tab, TabsWrapper } from "@draftkings/dk-tab-switcher";
import "blocks/PlayerPage/ui/PlayerPage.less";
class PlayerPageBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = props.dataProvider;
    }
    render() {
        return (React.createElement("div", { className: "player-page" },
            React.createElement(Header, Object.assign({}, this.state.header)),
            React.createElement(TabsWrapper, null,
                React.createElement(Tab, { route: this.state.dict.OddsTab, controller: this.state.tabSwitcherController, isSelectedByDefault: true, navigationUrl: '' }, this.state.dict.OddsTab)),
            this.state.marketboard));
    }
}
export const PlayerPage = observer(PlayerPageBlock);
//# sourceMappingURL=PlayerPage.js.map